<template>
  <ul class="list-style-type-none">
    <li v-for="(f, name) in files" :key="name">
      <details>
        <summary>{{ name }}</summary>

        <ul>
          <li v-for="file in f['_files']" :key="file.name">
            <a :href="fileLink(file)" @click="fileClicked($event, file)">
              {{ file.name }}
            </a>
          </li>
        </ul>
        <FilesList :files="f['_subs']" @file-selected="reemitFileClicked" />
      </details>
    </li>
  </ul>
</template>

<script>
import { UPLOADS_URL } from "@/constants";

export default {
  name: "FilesList",
  props: {
    name: String,
    files: [Array, Object],
  },
  methods: {
    fileLink(file) {
      return `${UPLOADS_URL}/${file.path}/${file.name}`;
    },
    fileClicked(e, file) {
      e.preventDefault();
      this.$emit("file-selected", this.fileLink(file));
    },
    reemitFileClicked(filePath) {
      this.$emit("file-selected", filePath);
    },
  },
};
</script>

<style scoped>
.list-style-type-none {
  list-style-type: none;
  padding-inline-start: 1em;
}
summary {
  font-weight: bold;
  cursor: pointer;
  line-height: 1.7em;
  margin-top: 0.1em;
}
</style>
